<div id="momentum">
  <img
    src="./../../assets/P_A_Momentum.jpg"
    alt="Momentum Band"
    style="width: 100%"
  />
</div>
<h6 class="mt-15 textColor">Price and Availability application</h6>
<p class="mt-15">
  The automated P&A system will be developed in Web Base technology adopted in
  all manual process routine.
</p>
<div>
  <ul class="bullet-points">
    <li>
      To replace manual price and availability process with online application
      to improve purchasing efficiency through increasing automation &
      streamlining processes
    </li>
    <li>To automate tracking workflow process</li>
    <li>To eliminate manual email communication</li>
    <li>To keep the historical records of request P&A</li>
    <li>
      <a (click)="downloadManual()" href="javascript:void(0)">
        P&A Application Manual
      </a>
    </li>
    <li>
      <a (click)="previewFlowChart()" href="javascript:void(0)">
        P&A Process flow
      </a>
    </li>
  </ul>
</div>
